import { render, staticRenderFns } from "./extended-preferences-card.vue?vue&type=template&id=26e1dc12"
import script from "./extended-preferences-card.vue?vue&type=script&lang=js"
export * from "./extended-preferences-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports